import { render, staticRenderFns } from "./reformTabs.vue?vue&type=template&id=685f3012&scoped=true"
import script from "./reformTabs.vue?vue&type=script&lang=js"
export * from "./reformTabs.vue?vue&type=script&lang=js"
import style0 from "./reformTabs.vue?vue&type=style&index=0&id=685f3012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685f3012",
  null
  
)

export default component.exports